import React, { useEffect, useState } from 'react';
import { useTalentos } from '../../../../application/talentos/hooks/useTalentos';
import ToolbarComponent from '../../../ui/section';
import DynamicTable from '../../../ui/table2';
import Loader from '../../../ui/loader';
import { ModalConfirm } from '../../../ui/modal2';
import FloatingButton from '../../../ui/floatButton';
import NavigationService from '../../../../utils/history';
import './style.css';

const CreditCodesPage = () => {
    const {
        creditCodes,
        getCreditCodes,
        deleteCode,
        getCreditTableColumns,
        getCreditTableCustomElements
    } = useTalentos().creditCodes;

    const [filters, setFilters] = useState({
        status: '',
        limit: 20,
        skip: 0
    });
    const [removeModal, setRemoveModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    useEffect(() => {
        loadData();
    }, [filters]);

    const loadData = async () => {
        await getCreditCodes(filters);
    };

    const handleGenerateNew = () => {
        NavigationService.navigateTo('/talentos/credit-codes/generate');
    };

    const handleViewCode = (code) => {
        NavigationService.navigateTo(`/talentos/credit-codes/${code}`);
    };

    const handleDelete = (code) => {
        setCurrentId(code);
        setRemoveModal(true);
    };

    const handleRemoveConfirm = async () => {
        if (currentId) {
            try {
                await deleteCode(currentId);
                await loadData();
                setRemoveModal(false);
                setCurrentId(null);
            } catch (err) {
                console.error('Error al eliminar código:', err);
            }
        }
    };

    const columns = getCreditTableColumns();
    const customElements = getCreditTableCustomElements(handleViewCode);

    return (
        <>
            <ToolbarComponent label="Códigos de Crédito" showBackButton={false}>
                <DynamicTable
                    headers={columns}
                    data={creditCodes}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando códigos..." />}
                    isLoading={false}
                    emptyText="No hay códigos de crédito disponibles"
                />
            </ToolbarComponent>
            <FloatingButton onClick={handleGenerateNew} />
            <ModalConfirm 
                isOpen={removeModal} 
                onClose={() => setRemoveModal(false)} 
                onAccept={handleRemoveConfirm}
                title="¿Eliminar código?"
                message="Esta acción no se puede deshacer."
            />
        </>
    );
};

export default CreditCodesPage;
